/**
 * PDP sticky mobile CTA bar
 *
 * Shows the bar rendered by snippets/pdp-sticky-atc.liquid once the price
 * block has scrolled off AND the real button grid is out of view, so the bar
 * never covers the buttons it mirrors.
 *
 * The bar does NOT own an add-to-cart path of its own. Its button proxies a
 * click to the real `.add-to-cart` submit button inside the product form, so
 * every existing behaviour still runs unchanged: the ajax cart in
 * theme.js:ProductForm.addItemFromForm, the made-to-order agreement gate, and
 * the cart drawer. Duplicating the fetch here would have meant duplicating
 * that gate too, and the two copies would drift.
 *
 * The one case the proxy cannot cover is the agreement checkbox. theme.js
 * reveals `#error-text-cb-so` next to the checkbox on a blocked submit, and
 * from the sticky bar that error is roughly a screen and a half above the
 * fold where she will never see it. So when the checkbox is visible and
 * unchecked we scroll it into view first and let the normal UI take over.
 */
(function () {
  var bar = document.querySelector('[data-pdp-sticky]');
  if (!bar) return;

  var form = document.querySelector('form.product-single__form') || document.querySelector('[data-product-form]');
  var priceBlock = document.querySelector('.product-block--price');
  var realAddBtn = document.querySelector('.product-single__form .add-to-cart') || document.querySelector('.add-to-cart');
  var btnGrid = realAddBtn ? realAddBtn.closest('.x-grid') : null;

  // Without a real button there is nothing to proxy to, so the bar would be a
  // dead control. Better to never show it.
  if (!realAddBtn) return;

  var stickyAdd = bar.querySelector('[data-pdp-sticky-add]');
  var stickyPrice = bar.querySelector('[data-pdp-sticky-price]');
  var ctaEl = btnGrid || realAddBtn;

  /**
   * Geometry is read live here rather than taken from the IntersectionObserver
   * entry. An observer entry carries the rect as captured at the moment the
   * threshold was crossed, and on a single large jump (back-navigation scroll
   * restore, an anchor link, scrollTo) that rect can be an intermediate value
   * still showing the price on screen. The observer then never fires again,
   * because no further threshold is crossed, and the bar stays hidden for the
   * rest of the visit. Reading the DOM at decision time cannot go stale.
   */
  function render() {
    var priceRect = priceBlock ? priceBlock.getBoundingClientRect() : null;
    var ctaRect = ctaEl ? ctaEl.getBoundingClientRect() : null;
    var viewportH = window.innerHeight || document.documentElement.clientHeight;

    // Price has scrolled UP out of view. Distinguishes that from the price
    // simply sitting below the fold on first paint.
    var priceGone = priceRect ? priceRect.bottom < 0 : false;
    // Real CTA is on screen, so the bar would only cover what it mirrors.
    var ctaOnScreen = ctaRect ? ctaRect.bottom > 0 && ctaRect.top < viewportH : false;

    var shouldShow = priceGone && !ctaOnScreen;
    bar.hidden = !shouldShow;
    // `hidden` alone would skip the transition, so drive the transform too.
    if (shouldShow) {
      bar.classList.add('is-visible');
    } else {
      bar.classList.remove('is-visible');
    }
  }

  // Observers are the cheap trigger; the scroll listener is the backstop for
  // jumps that resolve without crossing a threshold the observer is watching.
  if (typeof IntersectionObserver !== 'undefined') {
    var io = new IntersectionObserver(render, { threshold: 0 });
    if (priceBlock) io.observe(priceBlock);
    if (ctaEl) io.observe(ctaEl);
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      ticking = false;
      render();
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  // Mirror the real button's state. theme.js toggles `disabled` on the real
  // button for sold-out variants, and dispatches variant:change on selection.
  function syncState() {
    if (!stickyAdd) return;
    stickyAdd.disabled = !!realAddBtn.disabled;

    var realText = realAddBtn.querySelector('[data-add-to-cart-text]');
    if (realText) {
      var label = realText.textContent.trim();
      if (label) stickyAdd.textContent = label;
    }

    if (stickyPrice) {
      var livePrice = document.querySelector('[data-product-price]');
      if (livePrice) {
        var priceText = livePrice.textContent.trim();
        if (priceText) stickyPrice.textContent = priceText;
      }
    }
  }

  document.addEventListener('variant:change', function () {
    // theme.js updates the button and price on the same event; one tick lets
    // it finish before we read the DOM back.
    setTimeout(syncState, 0);
  });

  if (stickyAdd) {
    stickyAdd.addEventListener('click', function (e) {
      e.preventDefault();
      if (stickyAdd.disabled) return;

      // The made-to-order / try-at-home agreement gate. theme.js only accepts
      // the submit when the wrapper is display:none (not applicable to this
      // variant) or the box is ticked.
      var agreementWrap = document.getElementById('wp-checkbox-special-order');
      var agreementBox =
        document.getElementById('i_agree_to_special_order') || document.getElementById('i_agree_to_buy');
      var wrapVisible = agreementWrap && window.getComputedStyle(agreementWrap).display !== 'none';

      if (wrapVisible && agreementBox && !agreementBox.checked) {
        agreementWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
        // Fire the real click too, so theme.js renders its own error text in
        // the place she is now looking.
        realAddBtn.click();
        return;
      }

      realAddBtn.click();
    });
  }

  // Close the bar while the cart drawer is open. CSS handles the common case
  // via html.js-drawer-open; this covers the add that opens the drawer.
  document.addEventListener('ajaxProduct:added', function () {
    bar.classList.remove('is-visible');
  });

  syncState();
  render();
})();
